<template>
  <div class="studio-card">
    <Img
      :src="coverUrl"
      :alt="title"
      class="studio-card__cover"
      :class="{ 'is-portrait': isPortrait }"
      :oss-params="{ format: 'webp' }"
      :object-fit="isPortrait ? 'contain' : 'cover'"
    />
    <div class="studio-card__content">
      <div class="studio-card__tags">
        <Tag class="studio-card__post-tag" v-for="(tag, idx) in tags" :key="idx" :label="tag" />
      </div>
      <h3 class="studio-card__title">{{ title }}</h3>
      <p class="studio-card__description">{{ description }}</p>
      <SSButton class="studio-card__button" size="normal" type="primary" @click="handleUseStudio">
        {{ $t('mian-fei-shi-yong-ci-chang-jing') }}
      </SSButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import SSButton from '@/design/atom/button.vue';
import Img from '@rendora/design/components/img/Img.vue';
import Tag from './tag.vue';

export interface IStudioCard {
  coverUrl: string;
  title: string;
  description: string;
  tags?: string[];
  identity: string;
  isPortrait?: boolean;
}

const props = defineProps<IStudioCard>();

const emit = defineEmits<{
  useStudio: [identity: string];
}>();

const handleUseStudio = () => {
  emit('useStudio', props.identity);
};
</script>

<style lang="scss" scoped>
.studio-card {
  @apply flex-col justify-start;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    /* 投影 - 中 */
    box-shadow: 0 2px 20px 0 rgba(18, 25, 38, 0.1);
  }

  .studio-card__cover {
    width: 100%;
    height: auto;
    aspect-ratio: 16/9;
    background: var(--x-back-3);

    &.is-portrait {
      flex: 1;
      height: 0;
      width: auto;
    }
  }
  .studio-card__content {
    @apply flex-col justify-between gap-4;
    flex-shrink: 0;
    padding: 24px 23px 23px 23px;
    width: 100%;
    height: 274px;
    border-radius: 0 0 12px 12px;
    border-right: 1px solid var(--x-back-5);
    border-bottom: 1px solid var(--x-back-5);
    border-left: 1px solid var(--x-back-5);
    background: var(--x-back-1);
    overflow: hidden;
    box-sizing: border-box;
  }
  .studio-card__tags {
    @apply flex justify-start items-start;
    gap: 12px;
    height: 30px;
    .studio-card__post-tag {
      flex-shrink: 0;
      background-color: var(--x-back-3);
      font-size: 16px;
      line-height: 22px;
    }
  }
  .studio-card__title {
    color: var(--x-text-1);
    width: 100%;
    font-size: 20px;
    font-weight: 400;
    line-height: normal;
    margin: 0;
    display: -webkit-box; /* 必须配合 WebKitBox */
    -webkit-box-orient: vertical; /* 垂直排列子元素 */
    -webkit-line-clamp: 2; /* 限制行数，比如2行 */
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .studio-card__description {
    color: var(--x-text-5);
    // height: 84px;
    flex: 1;
    margin: 0;
    color: var(--x-text-5);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 200% */
    display: -webkit-box; /* 必须配合 WebKitBox */
    -webkit-box-orient: vertical; /* 垂直排列子元素 */
    -webkit-line-clamp: 3; /* 限制行数，比如3行 */
    overflow: hidden; /* 超出隐藏 */
    text-overflow: ellipsis; /* 可加可不加，主要是兼容 */
  }
}
.studio-card__button {
  padding: 8px 20px !important;
  line-height: 20px;
  display: flex;
  justify-content: center;
}
</style>
